export const topCardData=[
    {
        coinname:'BNB/BUSD',
        price:'418',
        doller:'$418',
        percentage:'- 1.28% ',
        volume:'109,267,865.92 BUSD',
        priceDown:true,
        pricecolor:true
    },
    {
        coinname:'ETH/USDT',
        price:'3499',
        doller:'$3500',
        percentage:'-1.79%',
        volume:'541,545,011.76 USDT',
        priceDown:true,
        pricecolor:false
    },
    {
        coinname:'DOT/BUSD',
        price:'35.00',
        doller:'$35',
        percentage:'+ 3.78%',
        volume:'63,324,607.43 BUSD B',
        priceDown:false,
        pricecolor:''
    },
    {
        coinname:'GRT/USDT',
        price:'0.8413',
        doller:'$1',
        percentage:'- 1.11%',
        volume:'28,538,521.44 USDT',
        priceDown:true,
        pricecolor:true
    },
]

export const topChartCardData=[
    {
        coinname:'BNB/BUSD',
        price:'418',
        doller:'$418',
        percentage:'- 1.28% ',
        volume:'109,267,865.92 BUSD',
        priceDown:true,
        pricecolor:true
    },
    {
        coinname:'ETH/USDT',
        price:'3499',
        doller:'$3500',
        percentage:'-1.79%',
        volume:'541,545,011.76 USDT',
        priceDown:true,
        pricecolor:false
    },
    {
        coinname:'DOT/BUSD',
        price:'35.00',
        doller:'$35',
        percentage:'+ 3.78%',
        volume:'63,324,607.43 BUSD B',
        priceDown:false,
        pricecolor:''
    },
    {
        coinname:'GRT/USDT',
        price:'0.8413',
        doller:'$1',
        percentage:'- 1.11%',
        volume:'28,538,521.44 USDT',
        priceDown:true,
        pricecolor:true
    },
]